<template>

  <div class="row">
    <!-- Title -->
    <div class="stage-title">Płatności</div>
    <hr/>
  </div>
  <div class="row">
    <div class="col-lg-12">
      <b-card no-body>
        <b-card-body>
          <b-card-title>
            <h4 class="card-title">O aplikacji</h4>
          </b-card-title>
          <b-card-text>
            Aplikacja PłatnościMP umożliwia zarządzanie centralne płatnościami za dokumenty zakupu. Umożliwia zarówno oznaczenie wybranych dokumentów jako zapłacone, jak również wystawienie dokumentów potwierdzenia wypłaty np. dok. Polecenia Przelewu.
            Dokumenty oznaczone jako opłacone, co kilka minut są aktualizowane w aptekach źródłowych w sieci. Co kilka minut następuje także pobranie świeżych faktur z podłączonych aptek.
            Jest to pierwsza wersja, wersja BETA aplikacji. Aktualnie ciągle trwają prace nad udoskonalaniem programu. Za wszelkie niedogodności przepraszamy.
          </b-card-text>
          <div @click="goToPaymentsRoute" class="btn btn-primary btn-block">Przejdź do płatności</div>
        </b-card-body>
      </b-card>
    </div>

    <div class="col-lg-12">
      <b-card no-body>
        <b-card-body>
          <b-card-title>
            <h4 class="card-title">Co nowego?</h4>
          </b-card-title>
          <b-card-text>
            <h4>Wersja 1.0.3.BETA</h4>
            <ul>
              <li>Dodano filtr wartości dokumentu oraz wartości pozycji dokumentu w zakładce dokumentów nieopłaconych i opłaconych</li>
              <li>Usunięto nadwyżkowe dokumenty pokazujące się w zakładce nieopłaconych dokumentów, które były opłacane lokalnie np. Hurtap itd.</li>
              <li>Wyłączono wyświetlanie się dokumentów z bufora zakupowego</li>
              <li>Poprawiono wyświetlanie się faktur kosztowych dla niektórych dostawców</li>

            </ul>
          </b-card-text>
          <b-card-text>
            <h4>Wersja 1.0.2.BETA</h4>
            <ul>
              <li>Dodano funkcję eksportu listy dokumentów do pliku CSV</li>
              <li>Funkcja eksportu listy dokumentów dostepna dla wystawionego dokumentu płatności</li>
              <li>Dodano funkcję wysyłki wiadomości e-mail do dostawcy z lista opłaconych dokumentów dla danego dokumentu płatności</li>
              <li>Poprawiono funkcje kopiowania komórek tabeli po dwukrotnym kliknięciu</li>
              <li>Dodano przyciski kopiowania do pól dot. odbiorcy w dokumencie przelewu</li>

            </ul>
          </b-card-text>
          <b-card-text>
            <h4>Wersja 1.0.1.BETA</h4>
            <ul>
              <li>Oddzielny widok listy wystawionych dokumentów płatności</li>
              <li>Funkcja filtrowania listy płatności po atrybutach dostawcy, apteki oraz dokumentu</li>
              <li>Funkcja zaznaczania wielu dokumentów na liście, na wielu stronach</li>
              <li>Funkcja ukrywania dokumentów niepotrzebnych, lub błędnych</li>
              <li>Możliwość zaimportowania dancych centralnego dostawcy bezpośrednio do dokumentu płatności</li>
              <li>Centralne kartoteki dostawców</li>
              <li>Możliwość masowego, lub automatycznego powiązania lokalnych dostawców z centralnymi</li>
              <li>Zmiana interfejsu graficznego na bardziej intuicyjny</li>
            </ul>
          </b-card-text>
          <b-card-text>
            <h4>Wersja 1.0.0.BETA</h4>
            <ul>
              <li>Funkcja gromadzenia danych o płatnościach aptek z sieci</li>
              <li>Funkcja listy dokumentów niopłaconych, opłaconych i błędych</li>
              <li>Funkcja wyszukiwarki na liście dokumentów, wyszukiwanie po numerze dokumentu, aptece i nazwie dostawcy</li>
              <li>Możliwość centralnego oznaczenia dokumentu jako opłacony, wraz z późniejszą synchronizacją w aptece źródłowej</li>
              <li>Możliwość wystawienia dokumentu Polecanie Przelewu [PP] dla opłaconych dokumentów i eksportu takiego dokumentu do pliku PDF</li>
            </ul>
          </b-card-text>

        </b-card-body>
      </b-card>
    </div>

  </div>



</template>
<script>
// import CommonChart from "@/components/widgets/CommonChart";

import {BCard, BCardBody, BCardText, BCardTitle} from "bootstrap-vue-next";
import {usePaymentsManagerModule} from "@/state/pinia/paymentsManagerModule";
import {useSimplepharmAuthModule} from "@/state/pinia/simplepharmAuthModule";
import {useCommonAppModule} from "@/state/pinia/commonAppModule";
import {useLazyLoaderModule} from "@/state/pinia/lazyloaderManagerModule";

export default {
  name: "PaymentsDashboardStage",
  props: {},
  components: {
    BCardText,
    BCard,
    BCardBody,
    BCardTitle
    // FontAwesomeIcon,
    // CommonChart,
  },
  data() {
    return {}
  },
  computed: {
    paymentsModule(){
      return usePaymentsManagerModule();
    },
    simplepharmAuth(){
      return useSimplepharmAuthModule();
    },
    commonModule(){
      return useCommonAppModule();
    },
    lazyloaderModule(){
      return useLazyLoaderModule();
    },
  },
  methods: {

    goToPaymentsRoute() {
      this.$router.push({name: 'PaymentsStage'})
    }

  },
  created() {
    this.simplepharmAuth.refreshToken().then(() => {
      this.commonModule.httpGetLicensedFeatures();
      this.commonModule.httpGetWorkingProfile();
    });
  },
};
</script>

<style scoped>

</style>
